import React from "react";

const PageNotFound = () => {
  return (
    <>
    </>
  );
};

export default PageNotFound;
